import { ChatBubble } from "./ChatBubble";
import type { ChatGroup } from "../../utils/chatGrouping";
import type { DocChatItem } from "@/lib/erp/docs";

type ChatBubbleGroupProps = {
  group: ChatGroup;
  currentUserId: string | undefined;
  onDelete?: (commentName: string) => void;
  onReact?: (commentName: string, emoji: string) => void;
  onReply?: (item: DocChatItem) => void;
  registerMessageRef?: (name: string, el: HTMLElement | null) => void;
  scrollToMessage?: (commentName: string) => void;
};

export function ChatBubbleGroup({
  group,
  currentUserId,
  onDelete,
  onReact,
  onReply,
  registerMessageRef,
  scrollToMessage,
}: ChatBubbleGroupProps) {
  const isMine = !!currentUserId && group.owner === currentUserId;

  return (
    <div className="space-y-0">
      {group.items.map((item, index) => (
        <ChatBubble
          key={item.name}
          item={item}
          isMine={isMine}
          isFirstInGroup={index === 0}
          isActivity={false}
          onDelete={onDelete}
          onReact={onReact}
          onReply={onReply}
          registerMessageRef={registerMessageRef}
          scrollToMessage={scrollToMessage}
        />
      ))}
    </div>
  );
}
